import React from 'react';
import styles from './Footer.module.scss';
import Logo from '../../assets/images/logo.svg';
import Typography from '@material-ui/core/Typography';
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';

const Footer = () => {
  const { s, google } = useStaticQuery(graphql`
    query {
      s: allFile(filter: { sourceInstanceName: { eq: "socialImages" } }) {
        nodes {
          relativePath
          name
          publicURL
        }
      }
      google: allFile(
        filter: {
          sourceInstanceName: { eq: "socialImages" }
          name: { eq: "google" }
        }
      ) {
        nodes {
          relativePath
          name
          childImageSharp {
            fluid(maxWidth: 1000, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `);
  const iconsMap = s.nodes.reduce((acc, next) => {
    acc[next.name] = next.publicURL;
    return acc;
  }, {});
  return (
    <>
      <div className={styles['footer__google']}>
        <div className={styles['footer__google__info-wrapper']}>
          <Img
            className={styles['footer__google__img']}
            fluid={google.nodes[0].childImageSharp.fluid}
            key={google.nodes[0].childImageSharp.fluid}
          />
          <Typography classes={{ root: styles['footer__google__text'] }}>
            Google SI and PS partner
          </Typography>
        </div>
      </div>
      <div className={styles.footer}>
        <div className={styles['footer__left-section']}>
          <Logo className={styles['footer__left-section_logo']} />
          <div className={styles['footer__left-section_rights']}>
            <span>© 2020 CyberVision, Inc, LLC.</span>
            <br />
            <span>All Rights Reserved.</span>
          </div>
          <div className={styles['footer__left-section_terms']}>
            <span>Terms and Conditions</span>
            <br />
            <span>Privacy Policy</span>
          </div>
        </div>
        <div className={styles['footer__right-section']}>
          <div className={styles['footer__section-services']}>
            <ul>
              <li>
                <Typography variant="body2" component="span" color="primary">
                  Services
                </Typography>
              </li>
              <li>
                <Typography variant="subtitle2" component="span">
                  Migration to Google cloud
                </Typography>
              </li>
              <li>
                <Typography variant="subtitle2" component="span">
                  Software engineering
                </Typography>
              </li>
              <li>
                <Typography variant="subtitle2" component="span">
                  IoT development
                </Typography>
              </li>
              <li>
                <Typography variant="subtitle2" component="span">
                  System support
                </Typography>
              </li>
              <li>
                <Typography variant="subtitle2" component="span">
                  CDAP support
                </Typography>
              </li>
            </ul>
          </div>
          <div className={styles['footer__section-nav']}>
            <ul>
              <li>
                <Typography variant="body2" component="span" color="primary">
                  Company
                </Typography>
              </li>
              <li>
                <Typography variant="body2" component="span" color="primary">
                  Clients & Testimonials
                </Typography>
              </li>
              <li>
                <Typography variant="body2" component="span" color="primary">
                  Blog
                </Typography>
              </li>
              <li>
                <Typography variant="body2" component="span" color="primary">
                  Contact us
                </Typography>
              </li>
            </ul>
          </div>
          <div className={styles['footer__section-addr']}>
            <ul>
              <li>
                <Typography variant="body2" component="span" color="primary">
                  E-Mail:
                </Typography>
              </li>
              <li>
                <Typography variant="subtitle2" component="span">
                  info@cybervisiontech.com
                </Typography>
              </li>
            </ul>
            <ul>
              <li>
                <Typography variant="body2" component="span" color="primary">
                  Mailing Address:
                </Typography>
              </li>
              <li>
                <Typography variant="subtitle2" component="span">
                  CyberVision, Inc.,
                </Typography>
              </li>
              <li>
                <Typography variant="subtitle2" component="span">
                  16047 Collins Ave, Suite 1704,
                </Typography>
              </li>
              <li>
                <Typography variant="subtitle2" component="span">
                  North Miami Beach, FL 33160
                </Typography>
              </li>
            </ul>
          </div>
        </div>
        <div className={styles['footer__social']}>
          <div className={styles['footer__social_block']}>
            <img
              className={styles['footer__social_block_linkedin']}
              src={iconsMap['linkedin']}
              alt="linkedin"
            />
          </div>
          <div className={styles['footer__social_block']}>
            <img
              className={styles['footer__social_block_twitter']}
              src={iconsMap['twitter']}
              alt="twitter"
            />
          </div>
          <div className={styles['footer__social_block']}>
            <img
              className={styles['footer__social_block_youtube']}
              src={iconsMap['youtube']}
              alt="youtube"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
